import React, { useEffect } from "react";
import { Portal } from "react-portal";

import { assets } from "../../assets/copy/play";
import COLORS from "../../assets/libs/colors";
import alcoholIcon from "../../assets/img/alcohol-char.png";
import restartIcon from "../../assets/img/restart-icon.png";
import playIcon from "../../assets/img/play-icon.png";

/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const Modal = ({
	isCorrect,
	setIsCorrect,
	currentInfo,
	setCurrentInfo,
	setIsOpen,
	currentSelection,
	setCurrentSelection,
	handleFormSubmit,
	isFinished,
	setModalIsActive,
	score,
}) => {
	useEffect(() => {
		console.log(`HELLO modal`);
		setModalIsActive(true);
		return () => {
			console.log(`GOODBYE modal`);
			setModalIsActive(false);
		};
	}, []);

	const Correct = () => (
		<>
			<div
				css={css`
					width: 50%;
					h1 {
						font-size: 3em;
						color: ${COLORS[currentInfo.color]};
						line-height: 0;
					}
					p {
						line-height: 1.5em;
					}
				`}
			>
				{/* HEADLINE */}
				<h1>Correct!</h1>

				{/* DESCRIPTIVE TEXT */}
				<p>
					<span
						css={css`
							font-weight: bold;
						`}
					>
						{currentInfo.bold}
					</span>
					{currentInfo.response}
				</p>

				{/* BUTTON */}
				<button
					type="button"
					onClick={() => {
						setIsCorrect();
						setIsOpen(false);
						setCurrentInfo(``);
						setCurrentSelection({});
					}}
					css={css`
						display: flex;
						justify-content: center;
						align-items: center;

						color: white;
						font-weight: bold;
						font-size: 1.5rem;

						background-color: ${COLORS[currentInfo.color]};
						border: none;
						border-radius: 6px;

						padding: 10px;
					`}
				>
					KEEP PLAYING
				</button>
			</div>

			{/* CHARACTER */}
			<img
				alt="icon"
				src={assets.cns.icon}
				css={css`
					position: absolute;
					right: -10%;
					top: 5%;
					height: 60%;
				`}
			/>

			{/* BOTTOM BAR */}
			<a href={assets[currentInfo.type].video} target="_blank">
				<div
					css={css`
						display: flex;
						justify-content: center;
						align-items: center;

						position: absolute;
						width: 100%;
						bottom: 0;
						margin-left: -2rem;
						margin-right: -2rem;
						padding: 2rem;
						box-sizing: border-box;

						border-radius: 0 0 6px 6px;

						color: #4e96c7;
						background-color: #16252a;
					`}
				>
					<img
						alt="play video"
						src={assets[currentInfo.type].playIcon}
						css={css`
							height: 60px;
							margin-right: 2em;
						`}
					/>

					<div
						css={css`
							display: flex;
							flex-direction: column;
						`}
					>
						<span
							css={css`
								text-transform: uppercase;
								font-weight: bold;
								margin-bottom: 0.25rem;
							`}
						>
							Want to learn more?
						</span>
						<span
							css={css`
								font-family: LunchBox;
								font-size: 3em;
							`}
						>
							Watch the video!
						</span>
					</div>
				</div>
			</a>
		</>
	);

	const Incorrect = () => (
		<>
			{/* CHARACTER */}
			<img
				alt="icon"
				src={alcoholIcon}
				css={css`
					position: absolute;
					left: -10%;
					bottom: 10%;
					height: 70%;
				`}
			/>

			<div
				css={css`
					position: absolute;
					right: 0;
					padding-right: 2em;
					width: 55%;

					h1 {
						font-size: 3em;
						color: ${COLORS.red};
						line-height: 0;
					}
					p {
						line-height: 1.5em;
						font-size: 1.25em;
					}
				`}
			>
				{/* HEADLINE */}
				<h1>Not Quite!</h1>

				{/* DESCRIPTIVE TEXT */}
				<p>
					<span
						css={css`
							font-weight: bold;
						`}
					>
						{currentInfo.bold}
					</span>
					{currentInfo.response}
				</p>

				{/* BUTTON */}
				<button
					type="button"
					onClick={() => {
						setIsCorrect();
						setIsOpen(false);
						setCurrentInfo(``);
						setCurrentSelection({});
					}}
					css={css`
						display: flex;
						justify-content: center;
						align-items: center;

						color: white;
						font-weight: bold;
						font-size: 1.5rem;

						background-color: ${COLORS.red};
						border: none;
						border-radius: 6px;

						padding: 10px;
					`}
				>
					NEXT
				</button>
			</div>
		</>
	);

	const Question = () => (
		<>
			<h1>{currentInfo.prompt}</h1>

			{/* ANSWERS */}
			<div
				css={css`
					display: flex;
					flex-direction: column;
					width: 50%;
				`}
			>
				<form
					onSubmit={handleFormSubmit}
					css={css`
						input {
							margin: 0.75em;
						}

						label {
							display: block;
							padding-left: 2.5em;
							text-indent: -2.5em;
						}
					`}
				>
					{currentInfo.options.map((option, i) => (
						<label htmlFor={`input-${i}`} key={`option-${i}`}>
							<input
								id={`input-${i}`}
								type="radio"
								value={option}
								name="option"
								checked={currentSelection.value === option}
								onChange={(event) => {
									setCurrentSelection(event.target);
								}}
							/>
							{option}
						</label>
					))}

					{/* BUTTON */}
					<button
						type="submit"
						// onClick={() => {
						// 	console.log(event.target.value, currentInfo.correctAnswer);
						// }}
						css={css`
							display: flex;
							justify-content: center;
							align-items: center;

							color: white;
							font-weight: bold;
							font-size: 1.5rem;

							background-color: ${COLORS[currentInfo.color]};
							border: none;
							border-radius: 6px;

							padding: 10px;
							margin: 20px;
						`}
					>
						SUBMIT
					</button>
				</form>
			</div>

			{/* CHARACTER */}
			<img
				alt="icon"
				src={assets[currentInfo.type].icon}
				css={css`
					position: absolute;
					right: -10%;
					bottom: 10%;
					height: 60%;
				`}
			/>
		</>
	);

	const Finish = () => (
		<>
			<div
				css={css`
					margin-left: -2rem;
					margin-right: -2rem;
					margin-top: -2rem;
					border-radius: 6px 6px 0 0;
					padding: 2rem;

					background: #0a2a35;
				`}
			>
				<div
					css={css`
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;
					`}
				>
					<h2
						css={css`
							color: #00a997;
							font-family: LunchBox;
							width: 100%;
							font-size: 4em;

							text-align: center;

							border-right: 2px solid #00a997;

							flex: 1 1 0px;
						`}
					>
						Great Job!
					</h2>

					<div
						css={css`
							display: flex;
							flex-direction: column;
							color: #963574;
							text-align: center;

							flex: 1 1 0px;
						`}
					>
						<span
							css={css`
								font-weight: bold;
								font-size: 1em;
							`}
						>
							FINAL SCORE:
						</span>
						<span
							css={css`
								font-weight: bold;
								font-size: 3em;
							`}
						>
							${score}
						</span>
					</div>
				</div>
				<div
					css={css`
						color: #4e97c7;
						text-align: center;
					`}
				>
					<div>Want to learn more?</div>
					<div>Click to watch a video about the developing brain!</div>
					<div
						css={css`
							display: flex;
							justify-content: center;
							align-items: center;
							margin-top: 2rem;

							margin-bottom: -50px;
						`}
					>
						{Object.keys(assets).map((asset, i) => (
							<a href={assets[asset].video} target="_blank" key={`vid-circle-${i}`}>
								<div
									css={css`
										text-align: center;
										color: #953575;
										font-weight: bold;

										&:after {
											/* content: "Watch"; */
											content: url(${playIcon});
											transform: scale(0.75);
											display: block;
											visibility: hidden;

											margin-top: -60px;
											opacity: 0.5;
										}

										&:hover {
											&:after {
												visibility: visible;
											}

											& > img {
												/* &:hover { */
												filter: brightness(50%);
												/* } */
											}
										}
									`}
								>
									<img
										css={css`
											height: 80px;
											margin-bottom: 0.5rem;
										`}
										alt="play video icon"
										src={assets[asset].circleIcon}
									/>
								</div>
							</a>
						))}
					</div>
				</div>
			</div>
			<a href="/play/Brain_Trivia">
				<div
					css={css`
						text-align: center;
						position: absolute;
						bottom: 0;
						right: 0;
						left: 0;
						margin-bottom: 3rem;

						font-size: 2em;
						font-weight: 300;
						color: #03aa97;

						display: flex;
						justify-content: center;
						align-items: center;

						img {
							height: 40px;
							margin: 1rem;
						}
					`}
				>
					<img src={restartIcon} alt="restart" />
					<span>Play Again</span>
				</div>
			</a>
		</>
	);

	const shouldDisplay = () => {
		if (isFinished) {
			return <Finish />;
		}

		if (isCorrect === undefined) {
			return <Question />;
		}

		if (isCorrect) {
			return <Correct />;
		}
		return <Incorrect />;
	};

	return (
		<Portal>
			{/* OVERLAY */}
			<div
				css={css`
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;

					background: ${(() => {
						if (isFinished === true) {
							return `#00a997ee`;
						}
						if (isCorrect === false) {
							return `#ff0000b0`;
						}
						return `${COLORS[currentInfo.color]}b0`;

						// isCorrect !== false ? COLORS[currentInfo.color] : COLORS.red;
					})()};

					display: flex;
					justify-content: center;
					align-items: center;
				`}
			>
				{/* MODAL */}
				<div
					css={css`
						width: ${isFinished ? `700px` : `560px`};
						height: ${isFinished ? `500px` : (isCorrect !== false ? `430px` : `350px`)};
						background: white;

						position: absolute;

						border-radius: 6px;
						box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);

						box-sizing: border-box;
						padding: 2rem;

						h1 {
							font-family: LunchBox;
							font-size: 1.5rem;
						}
					`}
				>
					{shouldDisplay()}
				</div>
			</div>
		</Portal>
	);
};

export default Modal;
